<script>
import FaqItem from './FaqItem.vue'
import TabItem from './TabItem.vue'

export default {
  name: 'FaqMain',

  components: {
    FaqItem,
    TabItem
  },

  data() {
    return {
      activeItemIndex: 0,
      activeQuestionItemIndex: '0_0_0'
    }
  },

  methods: {
    handleActiveIndexUpdate(index) {
      this.activeItemIndex = Number(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-wrapper {
  position: relative;

  .tabs__overflower {
    width: 40px;
    height: 100%;
    content: '';
    position: absolute;
    top: 0;
    z-index: 1;

    &--right {
      background-image: linear-gradient(to right, transparent, #fff);
      right: 0;
    }
  }

  .tabs {
    overflow-x: auto;
    overflow-y: hidden;
    overflow: visible;
    margin: 0;
    text-indent: 0;
  }
}
</style>
